/**
 * Created by Ko-Hsin on 16/05/2018.
 */

import {Component, ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';
import {AuthService} from "../../../core/auth.service";
import { StateService } from 'app/core/state.service';
import {AngularFirestore} from "angularfire2/firestore/firestore";
import {DatePipe} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {PaymentDialog, PaymentSummaryDialog} from "./dialogs";
import {TaxService} from "../../../payment/taxes.service";
import {PaymentService} from "../../../payment/payment.service";

@Component({
    selector: 'subscriptions',
    template: `
<div class="subscriptions">
    <div *ngIf="overview">
        <div class="flex justify-between items-center flex-wrap">
            <div class="smaller_text" >
                <alert-panel [(message)]="alert_message"></alert-panel>
                <div class="standalone_title">My Subscription</div>
                <div *ngIf="state.subscription_object && (pmt.selected_product || state.subscription_object.plan == 'free')" [ngClass]="{is_expired:is_expired}">
                   <div>
                        <strong [textContent]="state.subscription_object.plan == 'free' ? '30 day free trial' : pmt.selected_product.quantity+' '+pmt.selected_product.label"></strong> &nbsp; 
                    <span class="lighter">{{details}}</span>
                    <span class="lighter" *ngIf="pmt.selected_product">
                        {{pmt.selected_product.quantity * pmt.selected_product.rate | currency:current_currency.toUpperCase():''}}/{{pmt.selected_product.frequency}}
                        <span *ngIf="tax.schedule[current_country.code] && tax.schedule[current_country.code].has_sales_tax">{{tax.schedule[current_country.code].in_panel}}</span>
                    </span>
                    </div>
                    <div *ngIf="pmt.next_payment_attempt">Next billing date: {{pmt.next_payment_attempt * 1000 | date}}</div>
                    <div *ngIf="next">{{next}}</div>
                </div>
            </div>
            <div *ngIf="state.subscription_object && (pmt.selected_product || state.subscription_object.plan == 'free')">
                <button (click)="manage()">Manage Subscription</button>
            </div>
        </div>
        <mat-progress-bar *ngIf="!state.subscription_object || (!pmt.selected_product && state.subscription_object.plan != 'free')" mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="!overview && pmt.products">
        <div class="panel">
            <mat-select class="country_select" [(ngModel)]="current_country">
                <mat-option *ngFor="let country of countries" [value]="country">{{country.country}}</mat-option>
            </mat-select>
            <mat-progress-spinner *ngIf="pmt.products_loading" mode="indeterminate"></mat-progress-spinner>
            <div class="subscription_objects" *ngIf="current_country">
                <div *ngFor="let prod of pmt.products[current_country.currency]" [ngClass]="{hidden:!prod.quantity, selected:selected == prod}" class="subscription_object_container" (click)="updateCart(prod)">
                    <div class="subscription_object text-center" [ngClass]="{selected:(prod.is_current_plan && !selected) || selected == prod}">
                        <div class="quantity">{{prod.quantity}}</div>
                        <div class="">
                            <div class="prod_label">{{prod.label}}</div>
                            <div class="cost">{{prod.quantity * prod.rate | currency:current_country.currency.toUpperCase():''}}/{{prod.frequency}}</div>
                            <div class="cost" *ngIf="tax.schedule[current_country.code] && tax.schedule[current_country.code].has_sales_tax">{{tax.schedule[current_country.code].in_panel}}</div>
                        </div>
                    </div>
                    <div class="checkcircle_container">
                        <div *ngIf="prod.is_current_plan" class="checkcircle" (click)="updateCart(prod, true)"><mat-icon>check</mat-icon></div>
                    </div>
                </div>
            </div>
            <div class="options">
                <div>
                    <div><strong>Need More?</strong> <button>Contact Us</button></div>
                    <div>Cancel Subscription Delete Account</div>
                </div>
                <button class="bigger" [disabled]="!selected" (click)="goNext()">Next</button>
            </div>
        </div>
    </div>
</div>
    `,
    styles: [`
        mat-progress-spinner { margin: auto; }
        .smaller_text { font-size: 14px; line-height: 24px; }
        .lighter { color: #999; }
        .is_expired, .is_expired .lighter  { color: #fa0000;}
        .country_select {text-align: right; font-size:14px; margin-bottom:20px; }
        .subscriptions .panel { background-color: #fff; padding: 25px 25px 25px 15px;; max-width: 1200px; margin:auto; }
        .subscription_objects { display: flex; justify-content: center; flex-wrap: wrap; }
        .subscription_object_container { position:relative; margin: 0 0 10px 10px; flex-grow: 1; max-width: 200px;}
        .subscription_object { cursor:pointer; -webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px; border:1px solid #999; min-width: 160px; min-height: 120px; display: flex; flex-direction: column; justify-content: center; padding:3px; position:relative; }
        .selected.subscription_object,
        .subscription_object:hover { padding:0; border:4px solid #2255FF; }
        .hidden {display:none;}
        .quantity { font-family: "ff-netto-web",sans-serif; text-align: center; font-size: 20px; }
        .prod_label { text-transform: uppercase; font-weight: bold; font-size: 12px; }
        .cost {font-size: 12px; color: #999;}
        .checkcircle_container {position: absolute; top: -13px; width:100%; }
        .checkcircle { background-color: #2255FF; color: #fff; border-radius:100px; height: 30px; width: 30px; display: flex; justify-content: center; align-items: center; margin:auto; }
        .subscriptions .options { display:flex; justify-content: space-between; align-items: center; font-size: 12px; padding: 20px 0 20px 10px;}
        .account_panel button.bigger { background-color: #25f; color: #fff; padding: 10px 30px; padding: 10px 30px; height: fit-content; }
        .account_panel button.bigger:disabled { background-color: #ccc; }
    `],
    encapsulation: ViewEncapsulation.None
})
export class SubscriptionsComponent {

    @Input() overview;
    @Input() selected_product;
    @Output() onManage = new EventEmitter();
    countries = [
        {"code":"AT","currency":"eur","country":"Austria"},
        {"code":"AU","currency":"aud","country":"Australia"},
        {"code":"BE","currency":"eur","country":"Belgium"},
        {"code":"BG","currency":"eur","country":"Bulgaria"},
        {"code":"HR","currency":"eur","country":"Croatia"},
        {"code":"CY","currency":"eur","country":"Republic of Cyprus"},
        {"code":"CZ","currency":"eur","country":"Czech Republic"},
        {"code":"DK","currency":"eur","country":"Denmark"},
        {"code":"EE","currency":"eur","country":"Estonia"},
        {"code":"FI","currency":"eur","country":"Finland"},
        {"code":"FR","currency":"eur","country":"France"},
        {"code":"DE","currency":"eur","country":"Germany"},
        {"code":"EL","currency":"eur","country":"Greece"},
        {"code":"HU","currency":"eur","country":"Hungary"},
        {"code":"IE","currency":"eur","country":"Ireland"},
        {"code":"IT","currency":"eur","country":"Italy"},
        {"code":"LV","currency":"eur","country":"Latvia"},
        {"code":"LT","currency":"eur","country":"Lithuania"},
        {"code":"LU","currency":"eur","country":"Luxembourg"},
        {"code":"MT","currency":"eur","country":"Malta"},
        {"code":"NL","currency":"eur","country":"Netherlands"},
        {"code":"NZ","currency":"nzd","country":"New Zealand"},
        {"code":"PL","currency":"eur","country":"Poland"},
        {"code":"PT","currency":"eur","country":"Portugal"},
        {"code":"RO","currency":"eur","country":"Romania"},
        {"code":"SG","currency":"sgd","country":"Singapore"},
        {"code":"SK","currency":"eur","country":"Slovakia"},
        {"code":"SI","currency":"eur","country":"Slovenia"},
        {"code":"ES","currency":"eur","country":"Spain"},
        {"code":"SE","currency":"eur","country":"Sweden"},
        {"code":"UK","currency":"eur","country":"UK"},
        {"code":"US","currency":"usd","country":"USA"}
    ]
    public current_country;
    public current_currency = 'aud';
    subscription;
    selected = false;
    details = '';
    next;
    is_expired = false;
    alert_message;


    constructor(public state:StateService, public pmt:PaymentService, public afs:AngularFirestore, private datePipe:DatePipe, private dialog:MatDialog, public tax:TaxService){
        this.state.$requests.subscribe(request=>{
            if(request.request == 'subscriptionStatusSet') {
                this.handleSetSubscription();
            }
        })
        this.current_country = this.countries[1];
        this.handleSetSubscription();
    }
    handleSetSubscription(){
        if(!this.state.subscription_object) return;
        console.log('this.state.subscription_object ',this.state.subscription_object)
        this.subscription = this.state.subscription_object;
        if (this.subscription.plan == 'free') {
            let date = this.subscription.expiration.toDate();
            const date_formatted = this.datePipe.transform(date, 'dd MMM yyyy');
            this.next = 'Free trial end: ' + date_formatted;
            if(this.subscription.days_til_end > 1 ){
                this.details = this.subscription.days_til_end+' days remaining';
            }else if(this.subscription.days_til_end == 1){
                this.details = '1 day remaining';
            }else{
                this.details = '0 days remaining';
                this.is_expired = true;
            }
        }
    }
    manage(){
        this.onManage.emit('manage_subscription');
    }
    updateCart(prod){
        console.log(prod)
        this.pmt.planId = prod.plan;
        this.pmt.planQty = prod.quantity;
        this.selected = prod;
    }
    paymentSummary(){
        const psDialog = this.dialog['open'](PaymentSummaryDialog,{
            width: '480px',
            data: { prod:this.selected, curr_details:this.details, curr:this.state.subscription_object, current_country:this.current_country }
        });

        psDialog.afterClosed().subscribe(data => {
            if(data){
                console.log('data ',data)
                this.paymentMethod()
            }
        });
    }
    paymentMethod(){
        const pmDialog = this.dialog['open'](PaymentDialog,{
            width: '480px',
            data: { prod:this.selected, current_country:this.current_country }
        });

        pmDialog.afterClosed().subscribe(data => {
            if(data){
                console.log('data ',data)
                this.alert_message = 'Updated subscription successfully';
            }
        });
    }

    goNext(){
        this.paymentSummary();
        console.log('this is selected',this.selected)
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/account/components/subscriptions.ts